import type { ReactNode } from "react";
import { Text } from "@/components/Text";

/** A caption under a form control. */
export function Hint({ children, warning = false }: Readonly<{ children: ReactNode; warning?: boolean }>) {
  return (
    <Text variant="caption" tone={warning ? "warning" : "tertiary"}>
      {children}
    </Text>
  );
}
